export default __webpack_public_path__ + "static/media/Google-play.81385e3a.svg";